import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, type Role } from '../auth/AuthContext';

/** Oturum + (opsiyonel) rol koruması. */
export function ProtectedRoute({ children, roles }: { children: ReactNode; roles?: Role[] }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="route-loading">Yükleniyor…</div>;
  }
  if (!user) {
    return <Navigate to="/giris" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    // yetkisiz → kendi ana sayfasına
    return <Navigate to={user.role === 'bayi' ? '/bayi' : '/panel'} replace />;
  }
  return <>{children}</>;
}
